import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'SenderNameToIds',

  mixins: [ proxy({ type: 'array' }) ],

  computed: {
    disabledNames() {
      return this.proxy.map(({ sendername }) => {
        return sendername
      }).filter(Boolean)
    }
  },

  render
}
